Component['section-adicionar-endereco'] = () => {
	const wrapper = $('.section-adicionar-endereco-v1-adicionar-endereco');
	const form = wrapper.find('.section-adicionar-endereco-v1-adicionar-endereco-form form');

	/* Adiciona novo endereço na lista de endereços */
	const listaEnderecos = $('.gl-v1-radio-form');
	const message = $('.section-adicionar-endereco-v1-adicionar-endereco-success-msg');

	/**
	 * @type {{key: string, input: JQuery<HTMLInputElement>}[]}
	 */
	const formInputs = form.find('input, select').toArray().reduce((arr, item) => {
		const $i = $(item);
		return arr.concat({
			key: $i.attr('name'),
			input: $i
		})
	}, [])

	const addressListTemplate = {
		'ordem-servicos': `
			<li>
				<label>
					<input type="radio" checked name="endereco" id="endereco-{{index}}" />
					<span>
						{{endereco}}, {{numero}} - {{complemento}} - {{cidade}}, {{estado}} - CEP - {{cep}}
					</span>
				</label>
			</li>
		`,
		'meus-dados': `
			<li>
				<label>
					<input type="radio" checked name="endereco" id="endereco-{{index}}" />
					<span class="meus-dados-v1-lista-enderecos-item-dados">
						<span data-address="endereco">{{endereco}}</span>,
						<span data-address="numero">{{numero}}</span> -
						<span data-address="complemento">{{complemento}}</span> -
						<span data-address="bairro"></span> -
						<span data-address="cidade">{{cidade}}</span>,
						<span data-address="estado">{{estado}}</span> - CEP -
						<span data-address="cep">{{cep}}</span>
					</span>

					<div class="meus-dados-v1-lista-enderecos-item-btns">
						<button type="button" class="meus-dados-v1-editar-btn">EDITAR</button>
						<button type="button" class="meus-dados-v1-remover-btn">REMOVER</button>
					</div>
				</label>
			</li>
		`,
		'default': `
			<li>
				<label>
					<input type="radio" checked name="endereco" id="endereco-{{index}}" />
					<span>
						{{endereco}}, {{numero}} - {{complemento}} - {{cidade}}, {{estado}} - CEP - {{cep}}
					</span>
				</label>
			</li>
		`,
	};

	form.on('submit', ev => {
		ev.preventDefault();

		/* Obtenção dos dados */
		const data = formInputs.reduce((obj, item) => {
			obj[item.key] = (item.input.val() || '').trim()
			return obj;
		}, {})

		data.index = data.index || listaEnderecos.find('li').length + 1;
		data.estado = data.estado.toUpperCase()

		/* Validação de formulário - Valores vazios */
		const labels = form.find('label').removeClass('error');
		if (!form.validate([], 'label')) {
			return false;
		}

		/* Criação e inserção do novo item */
		const bodyClasses = $(document.body).attr('class').trim().split(' ').map(str => str.trim()).filter(str => str.length);
		const templateEntry = Object.entries(addressListTemplate).find(entry => bodyClasses.some(cls => cls == entry[0]))
		let template = templateEntry != null ? templateEntry[1] : addressListTemplate.default;

		for (let key in data) {
			template = template.replace(new RegExp(`{{${key}}}`, 'g'), data[key])
		}

		let copy = $(template.trim())
		const editableItem = listaEnderecos.find(`input[id="endereco-${data.index}"]`).closest('li');
		if (editableItem.length) {
			editableItem.before(copy).remove();
		} else {
			listaEnderecos.append(copy);
		}

		formInputs.forEach(inp => inp.input.val('').change());

		message.addClass('active');
		setTimeout(() => message.removeClass('active'), 1500);

		return false;
	})

	/* Botão de enviar primeiro formulário da página */
	const saveButton = $('.section-adicionar-endereco-v1-adicionar-endereco-save button');
	const saveForm = $('.form-v1-data-save');
	const saveMessage = $('.section-adicionar-endereco-v1-adicionar-endereco-save-success-msg');
	saveButton.on('click', () => {
		if (!saveForm.validate()) return;

		saveForm.submit();

		saveMessage.addClass('active');
		setTimeout(() => saveMessage.removeClass('active'), 1500)
	})
}
